const SET_COMPONENT = 'SET_COMPONENT';

export { SET_COMPONENT };
